import { render, staticRenderFns } from "./SlotFacility.vue?vue&type=template&id=28d3158c&"
import script from "./SlotFacility.vue?vue&type=script&lang=js&"
export * from "./SlotFacility.vue?vue&type=script&lang=js&"
import style0 from "./SlotFacility.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports